export class Joiner {
    constructor(
        joinerName,
        cellphone,
        zipcode,
        zipAddress,
        address,
        amount,
        brief,
        joinSeq
    ) {
        this.joinerName = joinerName;
        this.exponent = null; //대표자
        this.cellphone = cellphone;
        this.zipcode = zipcode;
        this.zipAddress = zipAddress;
        this.address = address;
        this.paymentType = "BANK";
        this.paymentStatus = "RSVT"; //RSVD => RSVT
        this.brief = brief;
        this.amount = amount;
        this.joinSeq = joinSeq;
    }
};

export class Runner {
    constructor(
        runnerSeq,
        ticketSeq,
        souvenir = null,
        choiceOption = null,
        runnerName = null,
        birthday = null,
        gender = null,
        cellphone = null,
        joinSeq = null,
    ) {
        this.runnerSeq = runnerSeq;
        this.ticketSeq = ticketSeq;
        this.souvenir = souvenir;
        this.choiceOption = choiceOption;
        this.runnerName = runnerName;
        this.birthday = birthday;
        this.gender = gender;
        this.cellphone = cellphone;
        this.joinSeq = joinSeq;
        this.backNo = null;
        this.chipNo = null;
    }
}
export const setJoiner = (ticketInfo, runnerList, groupName, name, cellphone, address, detailAddress, joinSeq) => {

    //접수자 정보 초기화
    let brief;
    let amount = 0;
    for (let runner in runnerList) {
        // console.log(ticketInfo[runnerList[runner].ticketSeq - 1].ticketPrice);
        amount += ticketInfo[runnerList[runner].ticketSeq - 1].ticketPrice;
    }
    if (amount > 0) {
        //전화번호 네자리로 brief 설정
        brief = `${name}${cellphone.slice(
            cellphone.length - 4,
            cellphone.length
        )}`;
    } else {
        brief = "무료";
    }
    let addressInBuilding = address.roadAddress; //건물명 있을때는 추가해주기
    if (address.buildingName) {
        addressInBuilding += `(${address.buildingName})`;
    }
    const joiner = new Joiner(
        name,
        cellphone,
        address.zonecode,
        addressInBuilding,
        detailAddress,
        amount,
        brief,
        joinSeq
    );
    // console.log(joiner.amount);
    if (amount === 0) {
        joiner.paymentStatus = "CMPL"; //무료인 경우, 신청과 동시에 결제완료 처리가 되야한다.
    }
    joiner.exponent = groupName;
    joiner.deposit = amount;
    return joiner;
}